import { formatWhatsAppTimestamp } from '@/lib/dateUtils';

interface DateSeparatorProps {
  timestamp: string;
}

export function DateSeparator({ timestamp }: DateSeparatorProps) {
  return (
    <div className="flex items-center justify-center my-3">
      <div className="bg-wa-in/95 dark:bg-wa-in/90 px-3 py-1 rounded-md shadow-sm">
        <span className="text-[12px] font-medium text-wa-text-muted uppercase tracking-wide">
          {formatWhatsAppTimestamp(timestamp).dateLabel}
        </span>
      </div>
    </div>
  );
}
